module.exports = __webpack_public_path__ + "img/dwg.5774a152.svg";